import LoadingSpinner from "../components/Spinner/spinner";
import { AuthConsumer } from "../providers/AuthProvider";
import GuardedRoute from "./GuardedRoute";

interface PrivateRouteProps {
    component: any
    path: any,
}
function PingAuthRoute() {
    return (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (isAuthenticated()) {
                    return <GuardedRoute />;
                  } else {
                    signinRedirect();
                    return <span><LoadingSpinner/></span>;
                  }
            }}
    </AuthConsumer>
    );
};

export default PingAuthRoute;